import { RemoteUpdateNomenclaturesFromEntity } from 'data/usecases';
import { makeApiUrlEntitiesNomenclatures } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateNomenclaturesFromEntity =
  (): RemoteUpdateNomenclaturesFromEntity => {
    return new RemoteUpdateNomenclaturesFromEntity(
      makeApiUrlEntitiesNomenclatures(),
      makeAxiosHttpClient(),
    );
  };
